<div class="login-page">
  <!-- Decorative background -->
  <div class="login-background"></div>

  <!-- Left branding panel (desktop only) -->
  <div class="login-branding">
    <div class="branding-content">
      <img src="assets/logo.png" class="branding-logo" alt="Enjochem Logo" />
      <h1>Enjochem Admin</h1>
      <p>Manage your business operations efficiently with our comprehensive admin dashboard.</p>

      <ul class="branding-features">
        <li>
          <i class="bi bi-graph-up-arrow"></i>
          <span>Real-time sales analytics</span>
        </li>
        <li>
          <i class="bi bi-box-seam"></i>
          <span>Inventory management</span>
        </li>
        <li>
          <i class="bi bi-people"></i>
          <span>Dealer & Customer tracking</span>
        </li>
        <li>
          <i class="bi bi-shield-check"></i>
          <span>Secure & reliable platform</span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Right form panel -->
  <div class="login-form-panel">
    <div class="login-form-wrapper">
      <!-- Mobile branding (mobile only) -->
      <div class="mobile-branding">
        <h2>Enjochem Admin</h2>
        <p>Business management made simple</p>
      </div>

      @if (sessionEndReason === authErrorCode.SESSION_SUPERSEDED) {
        <div class="session-ended-notice" role="alert">
          <i class="bi bi-shield-exclamation"></i>
          <div>
            <strong>You have been signed out</strong>
            <p>This account was signed in on another device. Only one device can be signed in at a time.</p>
          </div>
        </div>
      }

      <!-- Login card -->
      <div class="login-card">
        <div class="login-card-header">
          <img src="assets/logo.png" class="login-logo" alt="Enjochem Logo" />
          <h3 class="login-title">Welcome Back</h3>
          <p class="login-subtitle">Please enter your credentials to continue</p>
        </div>

        <div class="login-card-body">
          <form [formGroup]="credentialFormGroup" class="login-form">
            <!-- Email field -->
            <div class="form-group">
              <label for="email" class="form-label">Email Address</label>
              <div class="input-wrapper">
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="Enter your email"
                  autocomplete="email"
                  [class.is-invalid]="
                    credentialFormGroup.get('email')?.invalid &&
                    (credentialFormGroup.get('email')?.touched || credentialFormGroup.get('email')?.dirty)
                  " />
                <i class="bi bi-envelope input-icon"></i>
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  credentialFormGroup.get('email')?.invalid &&
                  (credentialFormGroup.get('email')?.touched || credentialFormGroup.get('email')?.dirty)
                ">
                <i class="bi bi-exclamation-circle me-1"></i>
                Please enter a valid email address
              </div>
            </div>

            <!-- Password field -->
            <div class="form-group">
              <label for="password" class="form-label">Password</label>
              <div class="input-wrapper password-field">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  class="form-control"
                  formControlName="password"
                  placeholder="Enter your password"
                  autocomplete="current-password"
                  [class.is-invalid]="
                    credentialFormGroup.get('password')?.invalid &&
                    (credentialFormGroup.get('password')?.touched || credentialFormGroup.get('password')?.dirty)
                  " />
                <i class="bi bi-lock input-icon"></i>
                <button
                  type="button"
                  class="password-toggle-btn"
                  [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                  [attr.aria-pressed]="showPassword"
                  (click)="showPassword = !showPassword">
                  <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </button>
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  credentialFormGroup.get('password')?.invalid &&
                  (credentialFormGroup.get('password')?.touched || credentialFormGroup.get('password')?.dirty)
                ">
                <i class="bi bi-exclamation-circle me-1"></i>
                Password is required
              </div>
            </div>

            <!-- Login button -->
            <button type="button" class="btn btn-login" (click)="onLogin()" [disabled]="isUserLogging">
              @if (isUserLogging) {
                <app-loading-spinner [inline]="true" class="me-1"></app-loading-spinner>
                <span>Signing in...</span>
              } @else {
                <span>Sign In</span>
                <i class="bi bi-arrow-right"></i>
              }
            </button>
          </form>
        </div>

        <!-- Optional: Add footer for forgot password or other links -->
        <!-- <div class="login-card-footer">
          <p>Forgot your password? <a href="#">Reset it here</a></p>
        </div> -->
      </div>

      <!-- Copyright -->
      <p class="login-copyright">&copy; {{ currentYear }} Enjochem Agro. All rights reserved.</p>
    </div>
  </div>
</div>
